import { render, staticRenderFns } from "./SBNavBar.vue?vue&type=template&id=0d306256&"
import script from "./SBNavBar.vue?vue&type=script&lang=js&"
export * from "./SBNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports